import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import GoogleButton from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue ${u.name.split(" ")[0]} !`);
      navigate("/tableau-de-bord");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Identifiants invalides");
    } finally { setBusy(false); }
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="text-3xl font-extrabold text-slate-900">Connexion</h1>
        <p className="mt-1 text-slate-600">Accédez à votre espace TymCoach.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input data-testid="login-email" required type="email" placeholder="Email" className="w-full border border-slate-200 rounded-xl p-3" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" required type="password" placeholder="Mot de passe" className="w-full border border-slate-200 rounded-xl p-3" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={busy} className="sc-btn sc-btn-primary w-full justify-center">{busy ? "Connexion…" : "Se connecter"}</button>
        </form>
        <div className="my-4 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />ou<span className="h-px flex-1 bg-slate-200" /></div>
        <GoogleButton />
        <div className="mt-4 text-sm text-slate-600">Pas encore de compte ? <Link className="text-emerald-700 font-semibold" to="/inscription">Créer un compte</Link></div>
        <div className="mt-8 p-4 rounded-xl bg-slate-50 border border-slate-200 text-xs text-slate-600">
          <b>Comptes démo :</b><br />
          Coach : coach@spotcoach.fr / Coach1234!<br />
          Client : client@spotcoach.fr / Client1234!<br />
          Salle : salle@spotcoach.fr / Salle1234!
        </div>
      </div>
      <Footer />
    </div>
  );
}
